import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getCurrentConference } from '../../../../base/conference';
import { translate } from '../../../../base/i18n';
import { getLocalParticipant } from '../../../../base/participants';
import { NOTIFICATION_TIMEOUT, showNotification } from '../../../../notifications';
import { FORM_PUBLISHED_NOTIFICATION } from '../../../actionTypes';
import { safeConferenceSendMessage } from '../../../conferenceUtils';
import FooterSection from '../sections/FooterSection';
import { PAGES } from '../utility/pages';
import { publishForm } from '../utility/reduxDataUtils';

import AlertMsg from './Alert';

const PublishForm = ({ t, ...props }) => {
    const [ formpublished, setFormPublished ] = useState(false);
    const [ showLoader, setShowLoader ] = useState(false);
    const [ invitationerror, setInvitationError ] = useState(false);
    const isPublishingRef = useRef(false);
    const localParticipant = useSelector(getLocalParticipant);
    const conference = useSelector(getCurrentConference);
    const dispatch = useDispatch();
    const recordindex = useSelector(
        state => state['features/clickandpledge']?.useraccountinfo || {}
    );

    const reloadstyle = {
        color: 'blue',
        cursor: 'pointer'
    };
    const loaderstyle = { width: '100%' };
    const spinnerstyle = { marginBottom: '20px' };
    const publish = async e => {
        e.preventDefault();

        if (isPublishingRef.current) {
            return;
        }

        isPublishingRef.current = true;
        setShowLoader(true);

        const publishData = {
            eId: props.meetingData.meetingUUID,
            Id: recordindex.recordId
        };

        try {
            const res = await publishForm(dispatch, publishData);

            if (res.success) {
                setFormPublished(true);
                props.onNavigate(PAGES.LOAD_FORM, { showDForm: true });
                setShowLoader(false);
            }
        } catch (err) {
            setFormPublished(true);
            setInvitationError(true);
            setShowLoader(false);
        } finally {
            isPublishingRef.current = false;
        }

        // Show notification locally for the publisher
        dispatch(showNotification({
            titleArguments: { name: localParticipant?.name },
            titleKey: 'notify.clickAndPledge'
        }, NOTIFICATION_TIMEOUT));

        // Broadcast notification to all other participants via conference
        const isBroadcastSent = safeConferenceSendMessage(conference, {
            type: FORM_PUBLISHED_NOTIFICATION,
            participantName: localParticipant?.name
        }, 'clickandpledge-givent:PublishForm:publishAndBroadcast');

        if (!isBroadcastSent) {
            dispatch(showNotification({
                titleKey: 'connection.DISCONNECTED',
                descriptionKey: 'clickandpledge.broadcastSkippedDisconnected'
            }, NOTIFICATION_TIMEOUT));
        }
    };

    const reLoad = () => {
        props.onNavigate(PAGES.LOAD_FORM, { showDForm: true });
    };

    return (
        <>
            <div className = 'recurring_transaction_container'>
                <div className = 'recurring_transaction_wrapper'>
                    <div className = 'recurring_transaction_card mt_2'>
                        <div className = 'recurring_transaction_card_header'>

                            {formpublished && !invitationerror && (
                                <AlertMsg
                                    isClose = { true }
                                    message = { t('clickandpledge.formPublishedSuccessfully') }
                                    type = 'success' />
                            )}
                            {invitationerror && (
                                <>
                                    <AlertMsg
                                        isClose = { true }
                                        message = { t('clickandpledge.sendInvitationTimeout') }
                                        type = 'failure' />
                                    <p
                                        onClick = { reLoad }
                                        style = { reloadstyle }>{t('clickandpledge.reload')}</p>
                                </>
                            )}
                            {showLoader && (
                                <div
                                    className = 'loader-container'
                                    style = { loaderstyle }>
                                    <div className = 'lds-ellipsis'>
                                        <div />
                                        <div />
                                        <div />
                                        <div />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className = 'recurring_transaction_card_body'>
                            <div className = 'form_input_wrapper d-flex justify-content-between mt_1'>
                                <button
                                    className = 'full_button tabindex_btn next'
                                    data-index = '0'
                                    disabled = { formpublished || showLoader }
                                    onClick = { publish }
                                    style = { spinnerstyle }
                                    type = 'button'>
                                    {showLoader
                                        ? (
                                            <div className = 'sppinner-givent'><span
                                                aria-hidden = 'true'
                                                className = { 'loading-spinner sm primary' }
                                                role = 'status'>
                                                <span className = 'spinner-border' />
                                            </span><span>{t('clickandpledge.processing')}</span></div>
                                        ) : <span className = ''>{t('clickandpledge.publishAndBroadcast')}</span>
                                    }
                                </button>
                            </div>
                        </div>
                        <FooterSection />
                    </div>
                </div>
            </div>
        </>
    );
};

export default translate(PublishForm);
